<template>
	<el-dialog append-to-body :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" destroy-on-close title="会员权益说明" width="60%">
		<div style="display: flex; flex-direction: column; align-items: anchor-center">
			<!-- <img src="../../assets/images/20260104-141356.jpg" alt="" style="max-width: 100%" /> -->
			<el-button v-if="!uinfo.levelId" type="primary" size="default" @click="handleBuyVIP" style="margin-top: 20px">购买会员</el-button>
		</div>
		<template #footer>
			<div class="dialog-footer">
			</div>
		</template>
	</el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	name: 'DialogVIPInfo',
	data() {
		return {
			dialogVisible: false
		};
	},
	computed: {
		...mapGetters('User', ['uinfo', 'uisLogin'])
	},
	methods: {
		...mapActions('Settings', ['setLoginShow']),
		handleBuyVIP() {
			if (!this.uisLogin) {
				this.dialogVisible = false;
				this.setLoginShow(true);
			} else {
				this.$router.push({
					path: '/VIPList'
				});
			}
		}
	}
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
	border-bottom: 1px solid #e8e8e8;
	margin-right: 0;
	background: #f5f7fa;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>
